export default __webpack_public_path__ + "static/media/vocalnet-artist.b28c6aa6.png";